<template lang="pug">
    main#app
        Header(:showContato="showContato")
        router-view
        ContatoWhatsapp(:showContato="showContato")
        Footer
</template>

<script>
import Header from '@components/Header/Header'
import Footer from '@components/Footer/Footer'
import ContatoWhatsapp from '@components/ContatoWhatsapp/ContatoWhatsapp'

export default {
    name: "template-app",
    components: {
        Header,
        Footer,
        ContatoWhatsapp,
    },
    metaInfo() {
        return this.meta
    },
    data() {
        return {
            meta: {
                title: ``,
                titleTemplate: `%s`
            },
        }
    },
    computed: {
        showContato() {
            return this.$route.name == 'home' || (this.$route.name == 'pagina' && this.$route.params.slug != 'trabalhe-conosco') 
        },
    },
    created() {
        this.$eventbus.$on('loaded-configuracoes', () => {
            this.meta.title = this.$configuracoes.seo_title || ''
            this.meta.titleTemplate = `%s ${ this.$configuracoes.seo_sufix || '' }`
        })
        this.setReferrer()
    },
    methods: {
        setReferrer() {
            if (document.referrer) {
                const regex = /.\w+.com|.\w+.br|.*\w+.org/g;
                let results = regex.exec(document.referrer);

                if (results != null && results.length > 0) {
                    var result = results[0].substr(1);
                    if (localStorage.getItem("referrer") == null || localStorage.getItem("referrer") != result) {
                        if (document.referrer.includes("google.com")) {
                            if (document.URL.split('gclid=')[1] == undefined)
                                localStorage.setItem("referrer", 'Google-Organico');
                            else
                                localStorage.setItem("referrer", 'Google-Adwords');
                        } else if (!result.match(/edu.br/g)) {
                            localStorage.setItem("referrer", result);
                        }
                    }
                }
            } else {
                localStorage.setItem("referrer", "SITE-ELISSA");
            }

            if (this.getParameterByName('utm_source') !== '')
                localStorage.setItem('referrer', this.getParameterByName('utm_source'));

            if (this.getParameterByName('gclid') !== '')
                localStorage.setItem("gclid", this.getParameterByName('gclid'))

            this.referrer = localStorage.getItem('referrer')
        },
        getParameterByName(name) {
            name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
    }
}
</script>

<style lang="stylus" scoped src="./App.styl"></style>